module.exports = __webpack_public_path__ + "static/media/delivery.c79488a4.svg";